export default {
      id: "icon-instagram-usage",
      viewBox: "0 0 67 67",
      url: "../icon/" + "icons.svg#icon-instagram-usage",
      toString: function () {
        return this.url;
      }
    }